/* tslint:disable */
import {
  Worker
} from '../index';

declare var Object: any;
export interface AvailabilityInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "OwnerId"?: string;
  "Availability_Profile__c"?: string;
  "Available__c"?: boolean;
  "End_Time__c"?: string;
  "GHGC_States__c"?: string;
  "GHGC_Weekend__c"?: string;
  "Global_Holiday_General_Calender_GHGC__c"?: string;
  "Hours__c"?: number;
  "Hours_GMT__c"?: number;
  "Job__c"?: string;
  "Job_Worker_Name__c"?: string;
  "MyWorkLeave_Request__c"?: string;
  "PHAC_States__c"?: string;
  "Program_Holiday_Approved_Calendar_PHAC__c"?: string;
  "Requested_By__c"?: string;
  "Requested_User_Type__c"?: string;
  "Shift_Type__c"?: string;
  "Source__c"?: string;
  "Start_Date__c"?: Date;
  "Start_Date_Time__c"?: Date;
  "Start_Date_Time_GMT__c"?: Date;
  "Start_Time__c"?: string;
  "Task__c"?: string;
  "Time_Zone__c"?: string;
  "Unavailability_Type__c"?: string;
  "Worker__c"?: string;
  "Worker_Availability_End__c"?: Date;
  "CreatedBy__c"?: string;
  "LastModifiedBy__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  worker?: Worker;
}

export class Availability implements AvailabilityInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "OwnerId": string;
  "Availability_Profile__c": string;
  "Available__c": boolean;
  "End_Time__c": string;
  "GHGC_States__c": string;
  "GHGC_Weekend__c": string;
  "Global_Holiday_General_Calender_GHGC__c": string;
  "Hours__c": number;
  "Hours_GMT__c": number;
  "Job__c": string;
  "Job_Worker_Name__c": string;
  "MyWorkLeave_Request__c": string;
  "PHAC_States__c": string;
  "Program_Holiday_Approved_Calendar_PHAC__c": string;
  "Requested_By__c": string;
  "Requested_User_Type__c": string;
  "Shift_Type__c": string;
  "Source__c": string;
  "Start_Date__c": Date;
  "Start_Date_Time__c": Date;
  "Start_Date_Time_GMT__c": Date;
  "Start_Time__c": string;
  "Task__c": string;
  "Time_Zone__c": string;
  "Unavailability_Type__c": string;
  "Worker__c": string;
  "Worker_Availability_End__c": Date;
  "CreatedBy__c": string;
  "LastModifiedBy__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  worker: Worker;
  constructor(data?: AvailabilityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Availability`.
   */
  public static getModelName() {
    return "Availability";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Availability for dynamic purposes.
  **/
  public static factory(data: AvailabilityInterface): Availability{
    return new Availability(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Availability',
      plural: 'Availabilities',
      path: 'Availabilities',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "Availability_Profile__c": {
          name: 'Availability_Profile__c',
          type: 'string'
        },
        "Available__c": {
          name: 'Available__c',
          type: 'boolean'
        },
        "End_Time__c": {
          name: 'End_Time__c',
          type: 'string'
        },
        "GHGC_States__c": {
          name: 'GHGC_States__c',
          type: 'string'
        },
        "GHGC_Weekend__c": {
          name: 'GHGC_Weekend__c',
          type: 'string'
        },
        "Global_Holiday_General_Calender_GHGC__c": {
          name: 'Global_Holiday_General_Calender_GHGC__c',
          type: 'string'
        },
        "Hours__c": {
          name: 'Hours__c',
          type: 'number'
        },
        "Hours_GMT__c": {
          name: 'Hours_GMT__c',
          type: 'number'
        },
        "Job__c": {
          name: 'Job__c',
          type: 'string'
        },
        "Job_Worker_Name__c": {
          name: 'Job_Worker_Name__c',
          type: 'string'
        },
        "MyWorkLeave_Request__c": {
          name: 'MyWorkLeave_Request__c',
          type: 'string'
        },
        "PHAC_States__c": {
          name: 'PHAC_States__c',
          type: 'string'
        },
        "Program_Holiday_Approved_Calendar_PHAC__c": {
          name: 'Program_Holiday_Approved_Calendar_PHAC__c',
          type: 'string'
        },
        "Requested_By__c": {
          name: 'Requested_By__c',
          type: 'string'
        },
        "Requested_User_Type__c": {
          name: 'Requested_User_Type__c',
          type: 'string'
        },
        "Shift_Type__c": {
          name: 'Shift_Type__c',
          type: 'string'
        },
        "Source__c": {
          name: 'Source__c',
          type: 'string'
        },
        "Start_Date__c": {
          name: 'Start_Date__c',
          type: 'Date'
        },
        "Start_Date_Time__c": {
          name: 'Start_Date_Time__c',
          type: 'Date'
        },
        "Start_Date_Time_GMT__c": {
          name: 'Start_Date_Time_GMT__c',
          type: 'Date'
        },
        "Start_Time__c": {
          name: 'Start_Time__c',
          type: 'string'
        },
        "Task__c": {
          name: 'Task__c',
          type: 'string'
        },
        "Time_Zone__c": {
          name: 'Time_Zone__c',
          type: 'string'
        },
        "Unavailability_Type__c": {
          name: 'Unavailability_Type__c',
          type: 'string'
        },
        "Worker__c": {
          name: 'Worker__c',
          type: 'string'
        },
        "Worker_Availability_End__c": {
          name: 'Worker_Availability_End__c',
          type: 'Date'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        worker: {
          name: 'worker',
          type: 'Worker',
          model: 'Worker',
          relationType: 'belongsTo',
                  keyFrom: 'Worker__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
